<template>
  <div>
    <a-upload
      v-model="fileList"
      listType="picture-card"
      :fileList="fileList"
      :remove="disabled ? null : removeFile"
      :multiple="false"
      :show-upload-list="true"
      :before-upload="disabled ? () => false : beforeUpload"
      :customRequest="disabled ? () => {} : customRequest"
      @preview="handlePreview"
      :disabled="disabled"
    >
      <div v-if="!disabled && (maxCount === -1 || maxCount > fileList.length)">
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div v-show="!loading" class="ant-upload-text">上传</div>
      </div>
      <div v-else-if="fileList.length === 0">
        <a-icon type="picture" />
        <div class="ant-upload-text">暂无图片</div>
      </div>
    </a-upload>
    <!-- 预览弹窗 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCancel">
      <img v-if="type === 'img'" alt="example" style="width: 100%" :src="previewImage" />
      <video v-else-if="type === 'video'" ref="previewVideo" style="width: 100%" :poster="previewPoster || poster || (previewImage + '?ci-process=snapshot&time=0&format=jpg')" :controls="true">
        <source :src="previewImage" type="video/mp4" />
      </video>
      <div v-else>
        <div>
          文件暂不支持在线预览, 请点击下载至本地后, 进行查看 <br /> <a :href="previewImage">下载文件</a>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {generateFilePath, uploadObject} from "@/api/tool/oss";

export default {
  props: {
    value: String,
    type: String, // 文件类型, "img" 图片, "video" 视频, null 不限制类型
    // 最大文件大小, 单位 兆M, 默认 20兆
    maxSize: {
      type: Number,
      default: 20
    },
    // 最大数量, -1 不限制数量
    maxCount: {
      type: Number,
      default: 1
    },
    /*文件夹前缀*/
    prefix: {
      type: String,
      default: "upload",
    },
    isArrayData: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 视频封面 URL（如 videoPic），存在时优先作为视频缩略图/预览封面
    poster: {
      type: String,
      default: ''
    }
  },
  created() {
    this.valueChange(this.value);
  },
  data() {
    return {
      fileList: [], // 文件集合
      loading: false, // 加载状态
      previewVisible: false, // 预览弹窗隐藏/显示
      previewImage: '', // 预览 img url
      previewPoster: '' // 预览封面（浏览器抓帧）
    }
  },
  methods: {
    // 删除图片
    removeFile(file) {
      this.fileList = this.fileList.filter(item => item.url !== file.url);
      this.$emit('input', this.isArrayData ? this.fileList : this.fileList.map(item => item.url).join(','));
    },
    // 预览按钮点击
    handlePreview(file) {
      this.previewImage = file.url;
      // 优先使用已抓到的第一帧作为预览封面
      this.previewPoster = (file.thumbUrl && file.thumbUrl.startsWith('data:image')) ? file.thumbUrl : '';
      this.previewVisible = true;
    },
    // 上传之前校验
    beforeUpload(file) {
      // 图片校验
      if (this.type == 'img' && !file.type.startsWith('image')) {
        this.$message.error('上传请上传图片文件');
        return false;
      }
      // 视频校验
      if (this.type == 'video' && !file.type.startsWith('video/mp4')) {
        this.$message.error('上传请上传 mp4 视频文件');
        return false;
      }
      // 大小校验
      if (file.size / 1024 / 1024 > this.maxSize) {
        this.$message.error(`上传文件大小不能超过 ${this.maxSize} MB`);
        return false;
      }
    },
    // 自定义上传请求
    customRequest(fileInfo, index) {
      this.loading = true;

      // 文件
      const uploadFile = fileInfo.file;

      // 文件夹目录
      const prefix = this.prefix
      const url = this.buildOssUrl(uploadFile.name, prefix);

      // oss 上传
      uploadObject(url, uploadFile).then(res => {
        this.fileList.push(this.createAntFileObj(res))
        this.$message.success('上传成功')
        this.loading = false;
        this.$emit('input', this.isArrayData ? this.fileList : this.fileList.map(item => item.url).join(','));
      })
    },
    // 构建 oss url
    buildOssUrl(fileName, prefix) {
      // 获取文件后缀
      const suffix = fileName.substring(fileName.lastIndexOf('.'))
      // 生成文件名称
      const filePath = generateFilePath(prefix, suffix)
      return filePath
    },
    // 文件随机 uid
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },
    // 预览关闭
    previewCancel() {
      this.previewVisible = false;
      // 视频暂停播放
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause();
      }
    },
    valueChange(newValue) {
      if (!newValue) {
        this.fileList = [];
        return;
      }
      if(typeof newValue === 'string') {
        const imgUrls = newValue.split(',');
        // 判断 url 是否存在, 不存在进行添加
        imgUrls.forEach(imgUrl => {
          for (let i = 0; i < this.fileList.length; i++) {
            const item = this.fileList[i];
            if (item.url == imgUrl) {
              return;
            }
          }
          this.fileList.push(this.createAntFileObj(imgUrl));
        });
      } else  {
        this.fileList = newValue.map(item => (this.createAntFileObj(item)))
      }
    },
    // 创建 ant fileList 的对象
    createAntFileObj(ossUrl) {
      const obj = {
        status: 'done',
        url: ossUrl,
        uid: this.getUidRandom(),
        name: ossUrl,
        thumbUrl: ossUrl
      };
      if (this.type === 'video') {
        // 视频：优先用传入封面，其次浏览器抓第一帧，最后回退腾讯云截帧
        if (this.poster) {
          obj.thumbUrl = this.poster;
        } else {
          this.captureVideoFrame(ossUrl, obj);
        }
      } else {
        obj.thumbUrl = ossUrl;
      }
      return obj;
    },
    // 浏览器端抓取视频第一帧作为缩略图（不依赖 COS 数据万象）
    captureVideoFrame(url, obj) {
      const video = document.createElement('video');
      video.crossOrigin = 'anonymous'; // 要求 COS 已配置 CORS，否则 canvas 会被污染
      video.muted = true;
      video.preload = 'auto';
      video.src = url;

      const drawAndSet = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth || 320;
          canvas.height = video.videoHeight || 180;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          obj.thumbUrl = canvas.toDataURL('image/jpeg'); // 跨域未配置时此处抛错
        } catch (e) {
          // CORS 未配置导致 canvas 被污染，回退到腾讯云 COS 实时截帧
          obj.thumbUrl = url + "?ci-process=snapshot&time=0&format=jpg";
        }
        this.fileList = [...this.fileList]; // 触发视图刷新
      };

      // loadeddata 后再 seek 到 0 秒，确保第一帧已解码
      video.addEventListener('loadeddata', () => {
        try {
          video.currentTime = 0;
        } catch (e) {
          drawAndSet();
        }
      });
      video.addEventListener('seeked', drawAndSet);
      video.addEventListener('error', () => {
        obj.thumbUrl = url + "?ci-process=snapshot&time=0&format=jpg";
        this.fileList = [...this.fileList];
      });
      video.load();
    }
  },
  watch: {
    // 监听上级 value 改变
    value(newValue) {
      this.valueChange(newValue);
    },
    // 监听封面改变，更新已生成文件的缩略图
    poster(newPoster) {
      if (this.type === 'video' && this.fileList.length > 0) {
        this.fileList.forEach(item => {
          item.thumbUrl = newPoster ? newPoster : item.url + "?ci-process=snapshot&time=0&format=jpg";
        });
        this.fileList = [...this.fileList];
      }
    }
  }
}
</script>
